import React from 'react';

import styled from 'styled-components';

import { UserManagementUserType } from './types';

const Intro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  line-height: 1.4;
`;

const UserName = styled.div`
  font-family: var(--font-medium);
  font-size: 14px;
  color: var(--text-primary);
`;

const UserEmail = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  user?: UserManagementUserType;
};

const UserManagementFeatureFlagsModalUserIntro = ({ user }: Props) => (
  <Intro>
    <UserName>{user?.name || user?.email || 'User'}</UserName>
    {user?.email && <UserEmail>{user.email}</UserEmail>}
  </Intro>
);

export default UserManagementFeatureFlagsModalUserIntro;
